import { ContactHQInfoData, ContactInfoSectionData } from './ContactsPage.types';

export const contactInfoSections: ContactInfoSectionData[] = [
  {
    title: 'Obchodní oddělení',
    items: [
      {
        email: 'dita.pochopova@mapomedical.cz',
        name: 'Dita Pochopová',
        phone: '+420 773 166 161',
        position: 'Vedoucí obchodního týmu',
      },
      {
        email: 'sarka.bilkovska@mapomedical.cz',
        name: 'Šárka Bílkovská',
        phone: '+420 773 993 090',
        position: 'Obchodní zástupce',
      },
      {
        email: 'martina.obrova@mapomedical.cz',
        name: 'Bc. Martina Obrová',
        phone: '+420 720 987 457',
        position: 'Obchodní zástupce',
      },
      {
        email: 'aneta.novakova@mapomedical.cz',
        name: 'Aneta Nováková',
        phone: '+420 607 045 565',
        position: 'Obchodní zástupce',
      },
      {
        email: 'radka.babystova@mapomedical.cz',
        name: 'Radka Burianová',
        phone: '+420 606 075 522',
        position: 'Specialista pro dezinfekci',
      },
      {
        email: 'istrejckova@mapomedical.cz',
        name: 'Iveta Strejčková',
        phone: '+420 722 994 624',
        position: 'Podpora pro objednávkový systém',
      },
    ],
  },
];

export const hqInfo: ContactHQInfoData = {
  title: 'Sídlo společnosti',
  name: 'MAPO medical s.r.o.',
  address: 'tř. Kosmonautů 1338/1c, Hodolany, 779 00 Olomouc',
  emails: ['www.mapomedical.cz', 'info@mapomedical.cz'],
  comment: 'Společnost je zapsána u Krajského soudu v Ostravě, oddíl C, vložka 955337',
  vatNo: '277 53 760',
  regNo: 'CZ699004407',
};
